export type NavMode = 'expanded' | 'thin' | 'hidden';

const KEY = 'bo-nav';

export function readNavMode(): NavMode {
  const stored = localStorage.getItem(KEY);
  if (stored === 'expanded' || stored === 'thin' || stored === 'hidden') return stored;
  return 'expanded';
}

export function writeNavMode(mode: NavMode) {
  localStorage.setItem(KEY, mode);
}

export function nextNavMode(mode: NavMode): NavMode {
  if (mode === 'expanded') return 'thin';
  if (mode === 'thin') return 'hidden';
  return 'expanded';
}
